@import '~style-sheet-helpers/core.less';
@import '../../../app-brand/entities/entity-layer.module.less';

.workstation-dropdownitem {
  display: flex;
  align-items: center;
  width: 100%;
  height: 36px;
  text-align: left;
  padding: 0 10px;
  border-bottom: 1px solid @scale-dropdown-items--border-color;
  font-size: 13px;
  white-space: nowrap;
  background: @scale-dropdown-items--background-color;
  cursor: default;

  > div {
    color: @scale-dropdown-items--text-color;
  }
}

.workstation-offline {
  font-size: 12px;
  display: inline;
  margin-left: 5px;
  font-weight: @bold;
}

.scale-selection {
  width: 100%;
  button {
    width: 100%;
  }
}
